
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/articles/how-music-boosts-productivity",
      function () {
        return require("private-next-pages/articles/how-music-boosts-productivity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/articles/how-music-boosts-productivity"])
      });
    }
  